// AI candidate-vs-job evaluation (#47b). Advisory decision support shown to the
// employer on an application. Mirrors the backend CandidateEvaluationResponse.

export type EvaluationVerdict = 'strong' | 'possible' | 'weak' | string;

export interface CandidateEvaluation {
    id: string;
    application_id: string;
    need_id: string;
    score: number;   // 0–100
    verdict: EvaluationVerdict;
    summary: string;
    strengths: string[];
    gaps: string[];
    recommendation: string;
    prompt_version: string;
    model: string;
    created_at: string;
}

// Runtime feature flags from GET /api/public/features (dark-launch gating).
export interface FeatureFlags {
    cv_evaluation: boolean;
    /** #299 — max ACTIVE Link chats per user; 0 = no cap. Comes from the backend
     *  because the backend ENFORCES it: a frontend constant would eventually
     *  disagree with the server, and the symptom would be a dialog promising
     *  something the API then refuses. */
    link_max_chats?: number;
}

// A lightweight application row for the Link @-mention picker (#47b Surface 2).
// Mirrors the backend MentionApplicationResponse.
export interface MentionApplication {
    id: string;
    applicant_name: string;
    need_role: string;
    need_title: string;
    status: string;
}

// Swedish labels + bar colour per verdict tier.
export const VerdictLabels: Record<string, string> = {
    strong: 'Stark match',
    possible: 'Möjlig match',
    weak: 'Svag match',
};
